import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import { USER_MEMBERSHIP_TYPE } from 'constants/common';

const RegisterSteps = ({ t, currentStep, membershipType }) => {
  const classNameByStep = (step) => {
    let className = 'im-step-bar2__item';
    if (step === currentStep) {
      className = `${className} im-step-bar2__item--inprogress`;
    } else if (step < currentStep) {
      className = `${className} im-step-bar2__item--completed`;
    }
    return className;
  };

  return (
    <div className="col-md-5 col-lg-4">
      <aside>
        <nav className="im-step-bar2 im-step-bar2--numbers">
          <div className={classNameByStep(0)}>
            <span className="im-step-bar2__item__text">{t('selectMembershipType')}</span>
          </div>
          <div className={classNameByStep(1)}>
            <span className="im-step-bar2__item__text">{t('enterMembershipInformation')}</span>
          </div>
          <div className={classNameByStep(2)}>
            <span className="im-step-bar2__item__text">{t('verifyYourEmailAddress')}</span>
          </div>
          <div className={classNameByStep(3)}>
            <span className="im-step-bar2__item__text">{t('verifyYourPhoneNumber')}</span>
          </div>
          {
            membershipType === USER_MEMBERSHIP_TYPE.CORPORATE
            && (
              <div className={classNameByStep(4)}>
                <span className="im-step-bar2__item__text">{t('enterCompanyInformation')}</span>
              </div>
            )
          }
        </nav>
      </aside>
    </div>
  );
};

RegisterSteps.propTypes = {
  currentStep: PropTypes.number,
  t: PropTypes.func,
  membershipType: PropTypes.string,
};

export default withTranslation('common')(RegisterSteps);
